/** Hint de discovery do Light Mode em Configurações. */
export const LIGHT_MODE_HINT_KEY = "vert-light-mode-hint-seen";

export function hasSeenLightModeHint() {
  try {
    return window.localStorage.getItem(LIGHT_MODE_HINT_KEY) === "1";
  } catch {
    return true;
  }
}

export function markLightModeHintSeen() {
  try {
    window.localStorage.setItem(LIGHT_MODE_HINT_KEY, "1");
  } catch {
    /* ignore quota / private mode */
  }
}
